import { render, staticRenderFns } from "./productClauseInfo.vue?vue&type=template&id=2d5ca32d&scoped=true"
import script from "./productClauseInfo.vue?vue&type=script&lang=js"
export * from "./productClauseInfo.vue?vue&type=script&lang=js"
import style0 from "./productClauseInfo.vue?vue&type=style&index=0&id=2d5ca32d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ca32d",
  null
  
)

export default component.exports